import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslatePipe } from '../../../core/pipes/translate.pipe';
import { AttachmentService } from '../../../core/services';

@Component({
  selector: 'app-detail-assign',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  templateUrl: './detail-assign.component.html',
  styleUrl: './detail-assign.component.css'
})
export class DetailAssignComponent {
  @Input() visible = false;
  @Input() mapping: any | null = null;
  @Input() showAddPayment = false;
  @Input() addPaymentDisabled = false;
  @Output() close = new EventEmitter<void>();
  @Output() addPayment = new EventEmitter<void>();
  @Output() addPaymentBlocked = new EventEmitter<void>();

  constructor(private readonly attachments: AttachmentService) {}

  closeModal(): void {
    this.close.emit();
  }

  triggerAddPayment(): void {
    if (this.addPaymentDisabled) {
      this.addPaymentBlocked.emit();
      return;
    }
    this.addPayment.emit();
  }

  formatDateTime(value: string | null | undefined): string {
    if (!value) {
      return 'N/A';
    }
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
      return 'N/A';
    }
    const day = `${date.getDate()}`.padStart(2, '0');
    const month = `${date.getMonth() + 1}`.padStart(2, '0');
    const year = date.getFullYear();
    const rawHours = date.getHours();
    const minutes = `${date.getMinutes()}`.padStart(2, '0');
    const period = rawHours >= 12 ? 'pm' : 'am';
    const hours12 = rawHours % 12 || 12;
    const hours = `${hours12}`.padStart(2, '0');
    return `${day}-${month}-${year} ${hours}:${minutes} ${period}`;
  }

  formatAmount(value: number | null | undefined): string {
    return `${Number(value ?? 0).toLocaleString('en-US')}`;
  }

  remainingAdvanceAmount(item: any): number {
    const advance = Number(item?.advanceAmount ?? 0);
    const used = Number(item?.usedAdvanceAmount ?? 0);
    return Math.max(0, advance - used);
  }

  openAttachmentPreview(attachment: any): void {
    const attachmentId = Number(attachment?.id);
    if (!Number.isFinite(attachmentId)) {
      return;
    }
    this.attachments.previewUrlByAttachmentId(attachmentId).subscribe({
      next: (url: string) => {
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.target = '_blank';
        anchor.rel = 'noopener noreferrer';
        anchor.click();
      }
    });
  }
}
